<template>
    <div class="home-container">
        <section class="d-flex flex-column align-items-start gap-3">
            <h4 class="extra-large-text light-black-color">მობილიზაციის ანალიტიკური ინფორმაცია</h4>
            <div class="common-statistics w-100">
                <commonStatisticsBlock v-for="(data, i) of commonStatistics">
                    <template v-slot:title>
                        <div class="d-flex align-items-center gap-2">
                            <h6 class="light-text extra-gray-color">სტატუსი: </h6>
                            <p :class="['font-weight-600','light-text', {'extra-green-color': data.going_typeID == 1}, {'extra-red-color': data.going_typeID == 2}, {'extra-orange-color':  data.going_typeID == 3}, {'light-blue-color':  data.going_typeID == 4}]">{{ `${data.going_typeID? localeGoingTypes[data.going_typeID - 1]: "უცნობია"}`}}</p>
                        </div>
                    </template>
                    <template v-slot:correspondingInfo>
                        <div class="d-flex gap-3 align-items-center">
                            <p class="statistics-info extra-black-color">{{ data.count }}</p>
                            <div>
                                <p class="light-text extra-gray-color">მთლიანი რაოდენობის</p>
                                <span :class="['light-text', 'font-weight-600', {'extra-green-color': data.going_typeID == 1}, {'extra-red-color': data.going_typeID == 2}, {'extra-orange-color':  data.going_typeID == 3}, {'light-blue-color':  data.going_typeID == 4}]">{{ this.mobilisationInfoCount != 0?`${(data.count / this.mobilisationInfoCount * 100).toFixed(2)}%`:"0%" }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:chart>
                        <commonStatisticsBarChart :mode="commonStatisticsBarColors[(data.going_typeID - 1) % 4]"/>
                    </template>
                </commonStatisticsBlock>
            </div>
        </section>
        <section v-if="pageMode != 3" class="main-info-section d-flex flex-column gap-3 align-items-start">
            <div class="d-flex align-items-start justify-content-between w-100">
                <h3 class="extra-large-text">მობილიზაცია</h3>
            </div>
            <div :class="['d-flex', 'search-container', 'w-100']">
                <form class="search-container-form" @submit.prevent="submitFilters">
                    <fieldset class="filters-wrapper">
                        <input v-model="filtersInfoObj.text" name="search-input" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
                        <Multiselect ref="cityID" v-model="filtersInfoObj.cityID" :options="this.localeMultiselectArray[0].options" :mode="this.localeMultiselectArray[0].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" id="city" name="city"
                        @select="(value, option) => allowNextMultiselect(value, true, i)" @deselect="() => blockNextMultiselects(0)" @clear="() => blockNextMultiselects(0)"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.localeMultiselectArray[0].placeholder" :disabled="this.localeMultiselectArray[0].isDisabled" insert/>
                        <Multiselect ref="districtID" v-model="filtersInfoObj.districtID" :options="this.localeMultiselectArray[1].options" :mode="this.localeMultiselectArray[1].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.localeMultiselectArray[1].placeholder" :disabled="this.localeMultiselectArray[1].isDisabled" insert/>
                        <Multiselect v-for="(data, i) of goingTypesMultiselectArray" v-model="filtersInfoObj.going_typeID" name="goingTypeID" id="goingTypeID" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" :canDeselect="true" :canClear="true"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                            <fieldset class="d-flex flex-column align-items-start">
                                <label for="hasComment" class="extra-light-text light-blue-color">შეიცავდეს კომენტარს</label>
                                <input name="hasComment" id="hasComment" type="checkbox" v-model="filtersInfoObj.hasComment">
                            </fieldset>
                            <button @click="resetFilters" type="button" class="extra-light-text extra-red-color ms-2" style="font-weight: 600; background-color: transparent;">გასუფთავება</button>
                            <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    </fieldset>
                </form>
                <excelFileDownloadComponent @igniteDownload="igniteDownload" excelFileName="mobilisation" :namesArray="['supporters', 'employees']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction"/>
            </div>
            <div class="d-flex align-items-center justify-content-between w-100">
                <div ref="getterButtonsWrappper" class="d-flex gap-3">
                    <template v-for="(data, i) of getterButtonsArray">
                        <primaryButtonComponent @click="setUserType(data.userTypeSetIndex)" buttonType="button" :mode="data.mode" class="large-text font-weight-600" buttonWidth="200px">
                            <template v-slot:content>
                                {{ data.content }}
                            </template>
                        </primaryButtonComponent>
                    </template>
                </div>
                <p class="extra-large-text pe-3">{{ `სულ ${pageMode == 0?"მხარდამჭერები":"თანამშრომლები"}: ${pagingInfo?.total??"0"}` }}</p>
            </div>
            
            <div class="common-scrollbar border-radius-20 w-100" style="background-color: var(--secondary-background-color); border-radius: 25px;">
                <div class="common-table-container common-scrollbar mt-2">
                    <table class="common-tablee">
                        <thead>
                            <tr>
                                <th class="light-text light-blue-color">სახელი</th>
                                <th class="light-text light-blue-color">გვარი</th>
                                <th class="light-text light-blue-color">ტელეფონი</th>
                                <th v-if="this.pageMode == 0" class="light-text light-blue-color">მისამართი</th>
                                <th class="light-text light-blue-color">უბნის ნომერი</th>
                                <th class="light-text light-blue-color">უბნის მისამართი</th>
                                <th v-if="this.pageMode == 0" class="light-text light-blue-color">სტატუსი</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(data, i) of mobilizationInfoArray">
                                <tr class="light-black-color light-text">
                                    <td>{{ `${data.name}` }}</td>
                                    <td>{{ `${data.surename}` }}</td>
                                    <td>{{ `${data.phone}` }}</td>
                                    <td v-if="this.pageMode == 0">{{ `${data.address}` }}</td>
                                    <td>{{ `${data.district}` }}</td>
                                    <td>{{ `${data.districtAddress}` }}</td>
                                    <td v-if="this.pageMode == 0" :class="['light-text', 'font-weight-500', {'extra-green-color': data.going_typeID == 1}, {'extra-red-color': data.going_typeID == 2}, {'extra-orange-color':  data.going_typeID == 3}]">{{ `${data.going_typeID? localeGoingTypes[data.going_typeID - 1]: "უცნობია"}`}}</td>
                                    <td v-if="this.pageMode == 0">
                                        <button class="blue-part-input d-flex align-items-center gap-2" style="width: min-content" @click="getMobilizationInfoByUser(data.respodentID, data.user_type), activateModalMode('comment', {userID: data.respodentID, user_type: data.user_type})">
                                            <p>კომენტარი</p>
                                            <img v-if="data.comment_count > 0" src="@/assets/images/bell.svg" alt="bell">
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <vue-awesome-paginate
                    :total-items="pagingInfo.total"
                    :items-per-page="pagingInfo.limit"
                    :max-pages-shown="4"
                    v-model="pagingInfo.offset"
                    :hide-prev-next-when-ends="false"
                    @click="paginationClickHandler"
                    class="my-4 align-self-center"
                />
            </div>
        </section>
    </div>
  <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="846px" @closeModal="triggerModal">
    <template v-slot:modal-content>
        <div class="d-flex flex-column align-items-center gap-4">
            <h5 class="extra-large-text">
              {{ modalTitle }}
            </h5>
            <div v-if="modalMode == 'comment'" class="w-100 d-flex flex-column align-items-center gap-3 justify-content-between">
                <div class="mobilisation-comments-wrapper w-100 d-flex flex-column align-items-center gap-2 common-vertical-overflow comments-scroll-wrapper common-scrollbar">
                    <div v-if="commentInfo.length > 0" v-for="(commentObj, i) of commentInfo" class="comments-wrapper d-flex flex-column align-items-start gap-2 extra-black-color light-text">
                        <h6 class="light-text extra-black-color">{{ `კომენტარის დამატების თარიღი: ${commentObj.comment_date}` }}</h6>
                        <p> <span class="font-weight-600">კომენტარი: </span>{{ `${commentObj.user_comment}` }}</p>
                        <p> <span class="font-weight-600">დაამატა იუზერმა: </span>{{ `${commentObj.addedByName} ${commentObj.addedBySurename}` }}</p>
                    </div>
                    <div v-else class="comments-wrapper d-flex flex-column align-items-start gap-2 extra-black-color light-text">
                        <h6 class="light-text extra-black-color">კომენტარები არ დაწერილა</h6>
                    </div>
                </div>
                <form @submit.prevent="addComment" class="w-100 d-flex flex-column align-items-center">
                    <fieldset class="w-100 d-flex flex-column gap-2 align-items-center">
                        <textarea style="max-width: none;" v-model="commentVmodels.user_comment" required id="comment" name="comment" maxlength="150" class="blue-part-input large-text" rows="10"></textarea>
                        <Multiselect v-for="(data, i) of goingTypesMultiselectArray" name="goingTypeID" id="goingTypeID" v-model="commentVmodels.going_typeID" :options="data.options" :mode="data.mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                    </fieldset>
                    <primaryButtonComponent buttonType="submit" class="large-text mt-4" :disabled="isSending">
                        <template v-slot:content>
                            დადასტურება
                        </template>
                    </primaryButtonComponent>
                </form>
            </div>
        </div>
    </template>
  </primaryModalComponent>
</template>
<script>
import commonStatisticsBlock from "@/components/commonStatisticsBlock.vue"
import searchFilterBarComponent from "@/components/search-filterBarComponent.vue"
import commonCardAccordion from "@/components/commonCardAccordion.vue"
import commonStatisticsBarChart from '@/components/commonStatisticsBarChart.vue';
import secondaryButton from "@/components/secondaryButton.vue";
import primaryModalComponent from "@/components/primaryModalComponent.vue";
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import Multiselect from '@vueform/multiselect'
import excelFileDownloadComponent from "@/components/excelFileDownloadComponent.vue";
import markerMapComponent from "@/components/markerMapComponent.vue";
export default {
    data(){
        return {
            currentPage: 1,
            isAccordionOpened: false,
            indexOfOpenedAccordion: null,
            localeGoingTypes: [
                "მოვდივარ",
                "არ მოვდივარ",
                "თავს შევიკავებ",
                "უცნობი",
            ],
            mobilizationInfoArray: [],
            getterButtonsArray: [
                {
                    content: "მხარდამჭერები",
                    mode: 0,
                    userTypeSetIndex: 2,
                },
                {
                    content: "თანამშრომლები",
                    mode: 1,
                    userTypeSetIndex: 1,
                },
            ],
            pageMode: 0,
            // for excel >>
            jsonToExcelArray: [],
            downloadInAction: false,
            // << for excel 
            // for modal >>
            showModal: false,
            modalMode: null,
            modalTitle: "",
            commentVmodels: {
                userID: null,
                user_type: null,
                user_comment: null,
                going_typeID: null,
            },
            goingTypesMultiselectArray: [
                {
                    placeholder: "სტატუსი",
                    options: [],
                    mode: "single",
                    isDisabled: false,
                    mobilizationID: null,
                },
            ],
            commentInfo: [],
            isSending: false,
            // for map  >>

            // << for map 
            // for paging and filtering
            pagingInfo: {
                offset: 1,
                limit: 10,
                total: 0,
            },
            filteringPagingInfo: {
                user_type: null,
                offset: null,
                text:null,
                cityID:null,
                districtID:null,
                going_typeID:null,
                hasComment:null,
            },
            localeMultiselectArray: [
                {
                    placeholder: "ქალაქი/ოლქი",
                    getterEndpoint: "getmunicipaliteti",
                    options: [],
                    sendName: "municipaliteti",
                    mode: "single",
                    isDisabled: false,
                    dependancyArray: [],
                },
                {
                    placeholder: "უბანი",
                    getterEndpoint: "getmunicipaliteti",
                    options: [],
                    sendName: "municipaliteti",
                    mode: "single",
                    isDisabled: true,
                    dependancyArray: [],
                },
            ],
            filtersInfoObj:{
                text: "",
                cityID: null,
                districtID: null,
                going_typeID: null,
                hasComment: false,
            },
            commonStatistics: [
                {
                    count: 0,
                    going_typeID: 1,
                },
                {
                    count: 0,
                    going_typeID: 2,
                },
                {
                    count: 0,
                    going_typeID: 3,
                },
                {
                    count: 0,
                    going_typeID: 4,
                }
            ],
            mobilisationInfoCount: 0,
            commonStatisticsBarColors: [
                "green",
                "red",
                "orange",
                "blue",
            ],
        }
    },
    components: {
        commonStatisticsBlock,
        searchFilterBarComponent,
        commonCardAccordion,
        commonStatisticsBarChart,
        secondaryButton,
        primaryModalComponent,
        primaryButtonComponent,
        Multiselect,
        excelFileDownloadComponent,
        markerMapComponent,
    },
    mounted(){
        this.removeAriaHidden();
        this.routerMountMovement(this.$route);
        this.getGoingTypes();
        this.$watch(() => this.localeMultiselectArray[0].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.cityID = this.filtersInfoObj.cityID;
                if(this.filtersInfoObj.cityID){
                    this.allowNextMultiselect(this.filtersInfoObj.cityID);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.localeMultiselectArray[1].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.districtID = this.filtersInfoObj.districtID;
            },
            { deep: true }
        );
        this.$watch(() => this.goingTypesMultiselectArray[0].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.going_typeID = this.filtersInfoObj.going_typeID;
            },
            { deep: true }
        );
        
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        if(isQueriesValid){
            next(true);
            if(this.filteringPagingInfo.user_type){
                if(this.filteringPagingInfo.user_type == 1){
                    this.pageMode = 1;
                }else if(this.filteringPagingInfo.user_type == 2){
                    this.pageMode = 0;
                }else{
                    this.pageMode = 0;
                }
            }else{
                this.pageMode = 0;
            }
            Object.keys(this.filtersInfoObj).forEach((key) => {
                if(key == "hasComment"){
                    this.filtersInfoObj[key] = this.filteringPagingInfo[key] == 1?true:false;
                }else if(key == "text"){
                    this.filtersInfoObj[key] = this.filteringPagingInfo[key];
                }else{
                    if(this.filteringPagingInfo[key]){
                        this.filtersInfoObj[key] = Number(this.filteringPagingInfo[key]);
                    }else{
                        this.filtersInfoObj[key] = this.filteringPagingInfo[key];
                    }
                }
            })
            if(!this.filtersInfoObj.cityID){
                this.blockNextMultiselects(1, this.localeMultiselectArray, this.filtersInfoObj);
            }

            if(this.filtersInfoObj.cityID){
                this.allowNextMultiselect(this.filtersInfoObj.cityID, 0, false, false, this.localeMultiselectArray, this.filtersInfoObj);
            }
            
            this.pagingInfo.offset = to.query.offset?(Number(to.query.offset) + 1):1;
            this.getterButtonsManagementHandler(this.pageMode);
            this.getMobilizationUsers(this.filteringPagingInfo);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
            if(isQueriesValid){
                if(this.filteringPagingInfo.user_type){
                    if(this.filteringPagingInfo.user_type == 1){
                        this.pageMode = 1;
                    }else if(this.filteringPagingInfo.user_type == 2){
                        this.pageMode = 0;
                    }else{
                        this.pageMode = 0;
                    }
                }else{
                    this.pageMode = 0;
                }

                Object.keys(this.filtersInfoObj).forEach((key) => {
                    if(key == "hasComment"){
                        this.filtersInfoObj[key] = this.filteringPagingInfo[key] == 1?true:false;
                    }else if(key == "text"){
                        this.filtersInfoObj[key] = this.filteringPagingInfo[key];
                    }else{
                        if(this.filteringPagingInfo[key]){
                            this.filtersInfoObj[key] = Number(this.filteringPagingInfo[key]);
                        }else{
                            this.filtersInfoObj[key] = this.filteringPagingInfo[key];
                        }
                    }
                })
                this.getCitiesAll();
                this.pagingInfo.offset = to.query.offset?(Number(to.query.offset) + 1):1;
                this.getterButtonsManagementHandler(this.pageMode);
                this.getMobilizationUsers(this.filteringPagingInfo);
            }else{
                this.$router.replace("/mobilisation");
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
        },
        async igniteDownload(){
            let firstArray = [];
            let secondArray = [];
            this.jsonToExcelArray = [];
            await this.$store.dispatch("getMobilizationUsers", {...this.filteringPagingInfo, user_type: 1 ,limit: Number.MAX_SAFE_INTEGER}).then((response) => {
                firstArray.push([
                    "სახელი",
                    "გვარი",
                    "პირადი ნომერი",
                    "ტელეფონის ნომერი",
                    "მისამართი",
                    "უბანი",
                    "უბნის მისამართი",
                    "სტატუსი",
                    "კომენტარების რაოდენობა",
                ]);
                response.data[0].forEach((obj) => {
                    let going_typeID = obj.going_typeID == 1?"მოდის":obj.going_typeID == 2?"არ მოდის":obj.going_typeID == 3?"თავს იკავებს":"უცნობია";
                    firstArray.push([
                        obj.name,
                        obj.surename,
                        obj.personal_number,
                        obj.phone,
                        obj.address,
                        obj.district,
                        obj.districtAddress,
                        going_typeID,
                        obj.comment_count,
                    ]);
                })
            })
            await this.$store.dispatch("getMobilizationUsers", {...this.filteringPagingInfo, user_type: 2, limit: Number.MAX_SAFE_INTEGER}).then((response) => {
                secondArray.push([
                    "სახელი",
                    "გვარი",
                    "პირადი ნომერი",
                    "ტელეფონის ნომერი",
                    "მისამართი",
                    "უბანი",
                    "უბნის მისამართი",
                    "კომენტარების რაოდენობა",
                ]);
                response.data[0].forEach((obj) => {
                    secondArray.push([
                        obj.name,
                        obj.surename,
                        obj.personal_number,
                        obj.phone,
                        obj.address,
                        obj.district,
                        obj.districtAddress,
                        obj.comment_count,
                    ]);
                })
            })
            this.jsonToExcelArray.push(firstArray);
            this.jsonToExcelArray.push(secondArray);

            this.downloadInAction = !this.downloadInAction;
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = null;
                if(key == "hasComment"){
                    this.filteringPagingInfo[key] = to.query[key]?1:0;
                }else{
                    this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
                }
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(key == "text"){
                    return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
                }else{
                    if(this.filteringPagingInfo[key] == null){
                        return true;
                    }else{
                        return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                    }
                }
            })
            return isQueriesValid;
        },
        changePageMode(mode){
            this.pageMode = mode;
        },
        resetFilters(){
            Object.keys(this.filtersInfoObj).forEach((key) => {
                this.filtersInfoObj[key] = null;
            })
            this.submitFilters();
        },
        submitFilters(){
            let tempObj = {};
            if(this.$route.query.user_type){
                tempObj["user_type"] = this.$route.query.user_type;
            }
            if(this.$route.query.offset){
                tempObj["offset"] = 0;
            }
            Object.keys(this.filtersInfoObj).forEach((key) => {
                if(this.filtersInfoObj[key]){
                    tempObj[key] = this.filtersInfoObj[key];
                }
            })
            

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...tempObj,
                }
            });
        },
        allowNextMultiselect(value, clear){
            if(value){
                this.$store.dispatch("getDistrictsByCity", value).then((response) => {
                    let tempArray = [];
                    for(let region of response.data){
                        for(let district of region.districts){
                            tempArray.push({
                                value: district.districtID,
                                label: {
                                    ge: `${district.district} - ${district.district_name}`,
                                    en: `${district.districteng} - ${district.district_nameeng}`,
                                }
                            });
                        }
                    }
                    if(clear){
                        this.filtersInfoObj.districtID = null;
                    }
                    this.localeMultiselectArray[1].options = tempArray;
                    this.localeMultiselectArray[1].isDisabled =false;
                })
            }
        },
        blockNextMultiselects(index){
            this.localeMultiselectArray[1].options = [];
            this.filtersInfoObj.districtID = null;
            this.localeMultiselectArray[1].isDisabled = true;
        },
        getCitiesAll(){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let city of response.data){
                    tempArray.push({
                        value: city.cityID,
                        label: {
                            ge: city.city,
                            en: city.cityeng,
                        }
                    });
                }
                this.localeMultiselectArray[0].options = tempArray;
            })
        },
        getMobilizationInfoByUser(userID, user_type){
            this.$store.dispatch("mobilizationInfoByUser", {userID, user_type}).then((response) => {
                this.commentInfo = response.data;
            })
        },
        getterButtonsManagementHandler(clickedButtonIndex){
            Array.from(this.$refs.getterButtonsWrappper.children).forEach((element, index) => {
                if(index == clickedButtonIndex){
                    this.getterButtonsArray[index].mode = 0;
                }else{
                    this.getterButtonsArray[index].mode = 1;
                }
            })
            this.pageMode = clickedButtonIndex;
        },
        
        addComment(){
            let isUserIDValid = this.$helper.checkNumber(this.commentVmodels.userID);
            let isUser_typeValid = this.$helper.checkNumber(this.commentVmodels.user_type);
            // let isUser_commentValid = this.$helper.checkJustString(this.commentVmodels.user_comment);
            let isGoingTypeIDValid = this.$helper.checkNumber(this.commentVmodels.going_typeID);
            
            if(isUserIDValid && isUser_typeValid && this.commentVmodels.user_comment && isGoingTypeIDValid){
                this.isSending = true;
                this.$store.dispatch("addMobilizationComments", this.commentVmodels).then((response) => {
                    if(response.status == 201){
                        this.$helper.showSwal("კომენტარი წარმატებით დაემატა", "success", "");
                        this.isSending = false;
                        this.triggerModal(false);
                        this.getMobilizationUsers(this.filteringPagingInfo);
                        // setTimeout(() => {this.$router.go()}, 1500);
                    }
                }).catch((error) => {
                    if(error?.response?.status == 422){
                        this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                        this.isSending = false;
                        setTimeout(() => {this.$router.go()}, 1500);
                    }
                })
            }
        },
        triggerModal(value){
            if(value == false){
                this.modalMode = null;
                this.modalTitle = null;
                this.commentInfo = [];
            }
            this.showModal = value;
        },
        activateModalMode(mode, options){
            this.modalMode = mode;
            
            if(this.modalMode == "comment"){
                this.commentVmodels.userID = options.userID;
                this.commentVmodels.user_type = options.user_type;
                this.commentVmodels.user_comment = null;
                this.commentVmodels.going_typeID = 4;
                
                this.modalTitle = "დაამატეთ კომენტარი";
            }
            this.triggerModal(true);
        },
        getGoingTypes(){
            this.$store.dispatch("getGoingTypes").then((response) => {
                let tempArray = [];
                for(let goingType of response.data){
                tempArray.push({
                    value: goingType.going_typeID,
                    label: {
                        ge: goingType.going_type,
                        en: goingType.going_typeeng,
                    },
                });
                }
                this.goingTypesMultiselectArray[0].options = tempArray;
            })
        },
        getMobilizationUsers(filteringPagingInfo){
            this.$store.dispatch("getMobilizationUsers", {...filteringPagingInfo, limit: this.pagingInfo.limit}).then((response) => {
                this.mobilizationInfoArray = [];
                this.mobilisationInfoCount = 0;
                this.pagingInfo.total = response.data[1];
                this.mobilizationInfoArray = response.data[0];
                this.commonStatistics.forEach((statisticsObj) => {
                    let foundObj = response.data[2].find((obj) => {
                        return (obj.going_typeID == statisticsObj.going_typeID);
                    })
                    statisticsObj.count = foundObj?foundObj.count:0;
                    this.mobilisationInfoCount += foundObj?foundObj.count: 0;
                });
            })
        },
        openAccordionOnIndex(index){
            this.indexOfOpenedAccordion = index;
            this.isAccordionOpened = true;
        },
        closeAccordionOnIndex(index){
            this.indexOfOpenedAccordion = null;
            this.isAccordionOpened = false;
        },
        setUserType(user_type){
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    user_type: encodeURIComponent(user_type),
                    offset: 0,
                }
            });
        },
        paginationClickHandler(value){
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    offset: encodeURIComponent(value - 1),
                }
            });
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
    }
}
</script>
<style scoped>
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.blue-part-input{
    justify-content: center;
    padding: 6px 12px;
    border-radius: 0.7em;
}
.main-info-section{
  overflow: hidden;
}

.cards-common-grid-wrapper{
    grid-template-rows: repeat(5, minmax(0, max-content));
}

.mobilisation-cards-and-map-wrapper{
    display: grid;
    grid-template-columns: auto 35%;
    grid-template-rows: 380px auto;
    gap: 1em;
}
.mobilisation-cards-and-map-wrapper .map-wrapper{
    background-color: var(--secondary-background-color);
    grid-column: 1 / 2;
    grid-row: 1 / 2;
}
.mobilisation-cards-and-map-wrapper .mobolisation-right-side{
    grid-column: 2 / 3;
    grid-row: 1 / 3;
}
.mobilisation-cards-and-map-wrapper .table-wrapper{
    background-color: var(--secondary-background-color);
    height: 300px;
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    padding: 1em 1em 3em 1em;
    overflow: hidden;
}
.common-table-container{
    padding: 0.5em;
    /* height: 100%; */
}
textarea.blue-part-input{
    resize: none;
    height: 80px;
    padding: 8px;
}
.problem-images-wrapper img{
    max-height: 92px;
    object-fit: contain;
}
.comments-wrapper{
    padding: 0.6em 1em;
    border: 2px solid var(--light-blue);
    border-radius: 1em;
}
.comments-scroll-wrapper{
    padding: 0;
}

/* map section >> */
.map-section-wrapper{
    display: grid;
    grid-template-columns: 65% 34%;
    grid-template-rows: 1fr;
    gap: 1%;
}
.map-section-wrapper .map-wrapper{
    grid-column: 1 / 2;
}
.map-section-wrapper .map-side-bar{
    grid-column: 2 / 3;
}
.map-section-wrapper .map-side-bar,.map-section-wrapper .map-wrapper{
    background-color: var(--secondary-background-color);
    border-radius: 20px;
}
.map-side-bar-header{
    border-bottom: 1px solid gray;
}
.map-side-bar-common-block{
    width: 100%;
    padding: 0.7em;
    background-color: rgb(236 236 236);
    border-radius: 10px;
}
.common-right-border{
    border-right: 3px solid gray;
    padding: 0.5em;
}
.mobilisation-comments-wrapper{
    height: 340px;
}
@media screen and (max-width: 1800px) {
    .search-container{
        justify-content: space-between;
        align-items: flex-start;
    }
    .search-container.mode-1 .primary-input{
        max-width: 400px;
    }
    .mobilisation-comments-wrapper{
        height: 300px;
    }
}

@media screen and (max-width: 1560px) {
    .mobilisation-cards-and-map-wrapper{
        grid-template-columns: auto 40%;
    }
    .mobilisation-comments-wrapper{
        height: 220px;
    }
    textarea.blue-part-input{
        max-height: 50px;
    }
    textarea.blue-part-input{
        max-height: 60px;
    }
}
</style>
